import React from 'react';
import Header from '@di-shared/features/common/Header';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import environmentStore from '@di-shared/features/environment/environmentStore';
import VehicleInspectionPaymentReservation from '@di-shared/features/public-service/vehicle-inspection/reservation/VehicleInspectionPaymentReservation';

export interface VehicleInspectionPaymentReservationPageProps {
  vin: string;
  reservationNumber: string;
}

function VehicleInspectionPaymentReservationPage({vin, reservationNumber}: VehicleInspectionPaymentReservationPageProps): JSX.Element {
  const {t} = useInferableTranslation();
  const puid = environmentStore.getState().puid;

  return (
    <div className="wrap">
      <Header right={<HeaderCloseButton />}>
        <h1 className="title_xsmall_b nav_center_title">{t('T40227')}</h1>
      </Header>
      <VehicleInspectionPaymentReservation
        vin={vin}
        puid={puid}
        reservationNumber={reservationNumber}
      />
    </div>
  );
}

export default VehicleInspectionPaymentReservationPage;
